export async function MarkSugerimentsRead() {
    const url = `${process.env.REACT_APP_API_URL}:8061/usuaris/sugeriments/read`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        return response.ok;
    } catch (e) {
        console.error("MarkSugerimentsRead error:", e);
        return false;
    }
}
